module.exports = function() {
  return new Worker(__webpack_public_path__ + "2de7be0f75c8165a2958.worker.js");
};